import { AppThunkAction } from '../reducers';

// services
import * as Services from '../../services/PersonRelationshipTypes.Services';

// actions
import * as Actions from '../actions';
import * as ActionEvents from '../actions/PersonRelationshipTypes.Actions';

// models
import { ErrorType } from '../../models/HttpError';
import { RelationShipTypeViewModel, RelationShipTypeCreateCommand, RelationShipTypeUpdateCommand } from '../../models/Entities/Person/RelationshipType/RelationshipTypeModels';

export type KnownAction =
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetAllRequestAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetAllSuccessAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetAllFailureAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetByIdRequestAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetByIdSuccessAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeGetByIdFailureAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeCreateRequestAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeCreateSuccessAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeCreateFailureAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeUpdateRequestAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeUpdateSuccessAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeUpdateFailureAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeDeleteRequestAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeDeleteSuccessAction
    | Actions.PersonRelationshipTypes.PersonRelationshipTypeDeleteFailureAction;

const NotAuthorizedError: ErrorType = {
    ErrorCode: 401,
    ErrorMessage: 'Not authorized',
    Errors: []
};

export const actionCreators = {
    GetRelationshipTypes: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_GETALL_FAILURE, error: NotAuthorizedError });
            return;
        }

        dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_GETALL_REQUEST });

        Services.GetRelationshipTypes(token)
            .then((response: RelationShipTypeViewModel[]) => {
                dispatch({
                    type: ActionEvents.PERSON_RELATIONSHIP_TYPE_GETALL_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_GETALL_FAILURE, error });
            });
    },

    GetRelationshipTypeById: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_GETBYID_FAILURE, error: NotAuthorizedError });
            return;
        }

        dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_GETBYID_REQUEST, id });

        Services.GetRelationshipTypeById(token, id)
            .then((response: RelationShipTypeViewModel) => {
                dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_GETBYID_SUCCESS, payload: response });
            })
            .catch((error: ErrorType) => {
                dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_GETBYID_FAILURE, error });
            });
    },

    CreateRelationshipType: (payload: RelationShipTypeCreateCommand): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_CREATE_FAILURE, error: NotAuthorizedError });
            return;
        }

        dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_CREATE_REQUEST, payload });

        Services.CreateRelationshipType(token, payload)
            .then((created: RelationShipTypeViewModel) => {
                dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_CREATE_SUCCESS, payload: created });
            })
            .catch((error: ErrorType) => {
                dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_CREATE_FAILURE, error });
            });
    },

    UpdateRelationshipType: (payload: RelationShipTypeUpdateCommand): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_UPDATE_FAILURE, id: payload.id, error: NotAuthorizedError });
            return;
        }

        dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_UPDATE_REQUEST, payload });

        Services.UpdateRelationshipType(token, payload)
            .then((updated: RelationShipTypeViewModel) => {
                dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_UPDATE_SUCCESS, payload: updated });
            })
            .catch((error: ErrorType) => {
                dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_UPDATE_FAILURE, id: payload.id, error });
            });
    },

    DeleteRelationshipType: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_DELETE_FAILURE, id, error: NotAuthorizedError });
            return;
        }

        dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_DELETE_REQUEST, id });

        Services.DeleteRelationshipType(token, id)
            .then(() => {
                dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_DELETE_SUCCESS, id });
            })
            .catch((error: ErrorType) => {
                dispatch({ type: ActionEvents.PERSON_RELATIONSHIP_TYPE_DELETE_FAILURE, id, error });
            });
    }
};
